import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import axios from "axios";
// eslint-disable-next-line no-unused-vars
import { FiPlus, FiTrash2, FiUser, FiRefreshCw } from "react-icons/fi";
import { Loader2 } from "lucide-react";

import "./User.css";

const User = () => {
  const auth = useSelector((state) => state.auth);
  const token = auth?.refreshToken;
  const userType = auth?.user?.userType;

  const baseUrl = process.env.REACT_APP_BASE_URL;

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const fetchUsers = async (page = 1) => {
    if (!token) return;

    setIsLoading(true);
    try {
      const response = await axios.post(
        `${baseUrl}/admin/users`,
        {
          page_number: page,
          page_size: 10,
          order_by: "DSC",
          user_type: "CUSTOMER",
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setData(response.data?.users || []);
      setTotalPages(response.data?.totalPage || 1);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!token) return;
    fetchUsers(currentPage);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, currentPage]);

  const handleDelete = async (id) => {
    if (!token) return;

    await axios.delete(`${baseUrl}/admin/deleteUser/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    setData((prev) => prev.filter((item) => item.id !== id));
  };

  const handleToggle = async (id, enabled) => {
    if (!token) return;

    await axios.put(
      `${baseUrl}/admin/user/state`,
      { id, active_status: enabled },
      { headers: { Authorization: `Bearer ${token}` } }
    );

    fetchUsers(currentPage);
  };

  return (
    <div className="user-page">
      <div className="user-page__inner">
        
        

        <main className="user-page__content">
          
          <div className="user-page__header">
            <div>
              <span className="user-page__eyebrow">User Management</span>
              <h1 className="user-page__title">
                {userType === "PARTNER" ? "Team Management" : "Customers"}
              </h1>
            </div>

            <Link to="/user/add-user" className="user-page__btn">
              <FiPlus size={16} />
              Create User
            </Link>
          </div>

          <div className="user-page__card">
            {isLoading ? (
              <div className="user-page__loader">
                <Loader2 className="user-page__loader-icon" size={32} />
                <span>Loading users…</span>
              </div>
            ) : data.length === 0 ? (
              <div className="user-page__empty">
                <FiUser size={28} />
                <p>No users found</p>
                <Link to="/user/add-user" className="user-page__ghost-btn">
                  Create First User
                </Link>
              </div>
            ) : (
              <>
                <table className="user-page__table">
                  <thead>
                    <tr>
                      <th>S.No.</th>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Role</th>
                      <th>Status</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((item, index) => (
                      <tr key={item.id}>
                        <td>{(currentPage - 1) * 10 + index + 1}</td>
                        <td>{item.first_name}</td>
                        <td>{item.email_address}</td>
                        <td>{item.roles?.[0]}</td>
                        <td>
                          <button
                            className={`user-page__status ${
                              item.active ? "active" : ""
                            }`}
                            onClick={() =>
                              handleToggle(item.id, !item.active)
                            }
                          >
                            {item.active ? "Active" : "Disabled"}
                          </button>
                        </td>
                        <td>
                          <button
                            className="user-page__icon-btn"
                            onClick={() => handleDelete(item.id)}
                          >
                            <FiTrash2 />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                <div className="user-page__pagination">
                  <button
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage((p) => p - 1)}
                  >
                    Prev
                  </button>

                  <span>
                    {currentPage} / {totalPages}
                  </span>

                  <button
                    disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage((p) => p + 1)}
                  >
                    Next
                  </button>
                </div>
              </>
            )}
          </div>
        </main>
      </div>
    </div>
  );
};

export default User;